import { request } from './request';

export const axiosBaseQuery = async ({ url, method = 'GET', data, params, options = {}, network, version }) =>
  request(url, {
    method,
    data,
    params,
    network,
    version,
    ...options,
  });

/**
 * Use this query as default query for new apis
 */
export const baseQuery = axiosBaseQuery;

/**
 * Use this base URL for any endpoint whose response sets, rotates, or clears
 * a cookie that the browser must treat as first-party to the admin portal.
 * Routing the request through a same-site host (set via VITE_AUTH_API_BASE_URL)
 * keeps the cookie from being suppressed by third-party-cookie blocking;
 * VITE_API_BASE_URL is the same-origin fallback for surfaces that don't need
 * the proxy.
 */
export const authApiBaseURL = `${import.meta.env.VITE_AUTH_API_BASE_URL || import.meta.env.VITE_API_BASE_URL}/`;

export const authBaseQuery = ({ url, method = 'GET', data, params, options = {} }) =>
  axiosBaseQuery({
    url,
    method,
    data,
    params,
    options: { ...options, baseURL: authApiBaseURL },
  });

/**
 * This query is intended for apis related to a network that usually works under
 * the path /collections/{id}/. Removes the necessity of adding the newtork id in
 * every endpoint.
 */
export const networkBaseQuery = ({ url, method = 'GET', data, params, options = {}, networkId }, { getState }) => {
  const { networks } = getState();

  return axiosBaseQuery({ url, method, data, params, options, network: networkId || networks?.active });
};

export const networkBaseQueryV2 = ({ url, method = 'GET', data, params, options = {}, networkId }, { getState }) => {
  const { networks } = getState();

  return axiosBaseQuery({ url, method, data, params, options, network: networkId || networks?.active, version: 'v2' });
};
